// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import { Container, Overlay, ContentWrapper, BottomSheetContainer, PlaceholderLabel, BottomSheetContent } from "./styles";

// Components
import { WebpSearchInput } from "components/WebpSearchInput";

// Types
type WebpBottomSheetProps = {
    id?: string;
    placeholder: string;
    handleOutsideClick?: () => void;
};

export const WebpBottomSheet: FunctionComponent<WebpBottomSheetProps> = ({ id, placeholder, handleOutsideClick, children }) => {
    const handleClick = (event: any) => {
        if (!!handleOutsideClick && (event?.target?.className?.toString().split(" ") ?? []).includes("webp-overlay")) {
            handleOutsideClick();
        }
    };

    return (
        <Container>
            <Overlay className="webp-overlay" onClick={handleClick}>
                <ContentWrapper>
                    <BottomSheetContainer>
                        <PlaceholderLabel>{placeholder}</PlaceholderLabel>

                        <WebpSearchInput id={id} />

                        <BottomSheetContent>{children}</BottomSheetContent>
                    </BottomSheetContainer>
                </ContentWrapper>
            </Overlay>
        </Container>
    );
};
